/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
import ProParameterMode from './ProParameterMode';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
//@import com/ibm/bi/platform/moser/common/generated/metadata/ProParameterMode (runtime) // new

/**
 * The properties of a function or procedure call parameter. <p>Java class for procParameterType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="procParameterType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="parameterName" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="mode" type="{}proParameterMode"/&gt; &lt;element name="datatype" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class ProcParameterType extends MoserObject{

	parameterName = null;

	mode = null;

	datatype = null;



	/**
	 * Gets the value of the parameterName property.
	 * @return {String} possible object is {@link String}
	 */
	getParameterName() {
		return this.parameterName;
	}

	/**
	 * Sets the value of the parameterName property.
	 * @param {String} value allowed object is {@link String}
	 */
	setParameterName(value) {
		var oldValue = this.parameterName;
		this.parameterName = value;
		this._setAndNotify(154, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the mode property.
	 * @return {ProParameterMode} possible object is {@link ProParameterMode}
	 */
	getMode() {
		return this.mode;
	}

	/**
	 * Sets the value of the mode property.
	 * @param {ProParameterMode} value allowed object is {@link ProParameterMode}
	 */
	setMode(value) {
		var oldValue = this.mode;
		this.mode = value;
		this._setAndNotify(155, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the datatype property.
	 * @return {String} possible object is {@link String}
	 */
	getDatatype() {
		return this.datatype;
	}

	/**
	 * Sets the value of the datatype property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDatatype(value) {
		var oldValue = this.datatype;
		this.datatype = value;
		this._setAndNotify(140, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>ProcParameterType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ProcParameterType</code> object from.
	 * @return {ProcParameterType} an object of type <code>ProcParameterType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createProcParameterType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ProcParameterType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 154, "parameterName", null));
		featureList.push(this.createFeature(false, true, false, 155, "mode", ProParameterMode));
		featureList.push(this.createFeature(false, false, false, 140, "datatype", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 154:
			this.setParameterName((value));
			break;
		case 155:
			this.setMode((value));
			break;
		case 140:
			this.setDatatype((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 154:
			return this.getParameterName();
		case 155:
			return this.getMode();
		case 140:
			return this.getDatatype();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 154:
			return this.getParameterName();
		case 155:
			return this.getMode();
		case 140:
			return this.getDatatype();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/ProcParameterType.js